import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, useParams } from 'react-router-dom';
import FormMaster from './components/Form/FormMaster';
import * as serviceWorker from './serviceWorker';
import './index.css';




const Root = () => {  
    return (
        <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASE_URL}>
            <Switch>
                <Route exact path="/eForm/:langCode" component={FormMaster} />                
            </Switch>
        </BrowserRouter>
    );
};

ReactDOM.render(<Root />, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
